// extracted by mini-css-extract-plugin
export default {"wrapper":"AiCharactersLayout_wrapper__6ytyc","noLeftSidebarWrapper":"AiCharactersLayout_noLeftSidebarWrapper__vpPic","container":"AiCharactersLayout_container__BGx3l"};